module.exports = __webpack_public_path__ + "static/media/3d-free-kick.8a789905.jpg";